import { createReducer, on, Action } from '@ngrx/store';
import * as BookingActions from '../actions/booking.actions';
import { Booking } from '@app/@core/data/models/booking.model';
import { FileItinerary } from '@app/@core/data/models/file-itinerary.model';
import { BookingDetail } from '@app/@core/data/models/booking-detail.model';
import { BookingReport } from '@app/@core/data/models/booking-report.model';
import { Document } from '@app/@core/data/models/document.model';

export interface BookingState {
  booking: Booking | null;
  bookingDetails: BookingDetail[] | null;
  fileItineraries: FileItinerary[] | null;
  bookingReport: BookingReport[] | null;
  documents: Document[] | null;
  documentLink: any;
  loadingBookings: boolean;
  loadBookingsErrors: any | null;
  bookingReportFailure: string | null;
}

export const initialState: BookingState = {
  booking: null,
  bookingReport: null,
  bookingDetails: null,
  fileItineraries: null,
  documents: null,
  documentLink: null,
  loadingBookings: false,
  loadBookingsErrors: null,
  bookingReportFailure: null,
};

const bookingReducer = createReducer(
  initialState,
  on(BookingActions.loadBooking, state => ({
    ...state,
    loadingBookings: true,
    loadBookingsErrors: null,
  })),
  on(BookingActions.loadBookingSuccess, (state, action) => ({
    ...state,
    loadingBookings: false,
    loadBookingsErrors: null,
    booking: action.payload.booking,
  })),
  on(BookingActions.loadBookingFailure, (state, action) => ({
    ...state,
    loadingBookings: false,
    booking: null,
    loadBookingsErrors: action.payload.error,
  })),
  on(BookingActions.loadBookingDetails, state => ({
    ...state,
    bookingDetails: null,
  })),
  on(BookingActions.loadBookingDetailsSuccess, (state, action) => ({
    ...state,
    bookingDetails: action.payload.details,
  })),
  on(BookingActions.loadBookingReport, state => ({
    ...state,
    bookingReport: null,
    bookingReportFailure: null,
  })),
  on(BookingActions.loadBookingReportSuccess, (state, action) => ({
    ...state,
    bookingReport: action.payload.report,
  })),
  on(BookingActions.loadBookingReportFailure, (state, action) => ({
    ...state,
    bookingReportFailure: action.payload.error,
  })),
  on(BookingActions.loadFileItineraries, state => ({
    ...state,
    fileItineraries: null,
  })),
  on(BookingActions.loadFileItinerariesSuccess, (state, action) => ({
    ...state,
    fileItineraries: action.payload.fileItineraries,
  })),
  on(BookingActions.loadBookingDocuments, state => ({
    ...state,
    documents: null,
  })),
  on(BookingActions.loadBookingDocumentsSuccess, (state, action) => ({
    ...state,
    documents: action.payload.documents,
  })),
  on(BookingActions.DownloadDocumentSuccess, (state, action) => ({
    ...state,
    documentLink: action.payload.documentLink,
  })),
  on(BookingActions.cleanDocumentLink, (state, action) => ({
    ...state,
    documentLink: null,
  })),
);

export function reducer(state: BookingState | undefined, action: Action) {
  return bookingReducer(state, action);
}
